<!-- 微信绑定 -->
<template>
  <div class="bind">
    <div class="top-box">
      <div class="centered">
        <div class="logo fl">
          <img src="./../assets/301.png" alt="微信" />
          <span>微信绑定</span>
        </div>
      </div>
    </div>
    <div class="bind-box">
      <h3>微信账号绑定</h3>
      <input
        type="text"
        id="username"
        placeholder="用户名"
        v-model="formLogin.loginUsername"
      />
      <input
        type="text"
        id="password"
        placeholder="密  码"
        v-model="formLogin.loginPassword"
      />
      <button @click="submitLogin">授权并登录</button>
    </div>
  </div>
</template>

<script>
import encrypt from "./../utils/encrypt";
import { getWxLoginInfo, bindTeacherWx, bindStudentWx } from "@/api/common";
import router, {
  resetRouter,
  defaultRoutes,
  newRoutes,
  newRoutes2,
} from "./../router";
import {
  getActive,
  setActive,
  removeActive,
  setType,
  setActiveName,
  setActive2,
  setToken,
  setUid,
  setPhone,
  getWinfo,
  setWinfo,
  removeWinfo,
} from "@/utils/auth";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      formLogin: {
        loginUsername: "",
        loginPassword: "",
      },
      loginType: 1,
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    async submitLogin2(response) {
      if (this.loginType == 1) {
        setToken(response.data.token);
        setUid(response.data.uid);
        resetRouter();
        var accessRoutes = await this.$store.dispatch("user/getRouter2");
        var routers = newRoutes2;
        if (newRoutes2[0].children.length == 1) {
          var child1 = newRoutes2[0].children.concat(accessRoutes);
        } else {
          var child1 = newRoutes2[0].children.slice(0, 1).concat(accessRoutes);
        }

        routers[0].children = child1;
        router.addRoutes(routers);
        router.options.routes = routers;
        setPhone("微信登录");
        setType(1);
        setActiveName("个人信息");
        removeActive();
        setActive2(1);
        this.$router.push({ name: "Common" });
        this.$message.success("登录成功");
      } else {
        setToken(response.data.token);
        setUid(response.data.uid);
        resetRouter();
        var accessRoutes = await this.$store.dispatch("user/getRouter");
        var routers = newRoutes;
        if (newRoutes[0].children.length == 1) {
          var child1 = newRoutes[0].children.concat(accessRoutes);
        } else {
          var child1 = newRoutes[0].children.slice(0, 9).concat(accessRoutes);
        }

        routers[0].children = child1;
        router.addRoutes(routers);
        router.options.routes = routers;
        setPhone("微信登录");
        setType(2);
        setActiveName("个人信息");
        removeActive();
        setActive2(1);
        this.$router.push({ name: "Common" });
        this.$message.success("登录成功");
      }
    },
    bindWX() {
      if (this.$route.query.type) {
        this.loginType = this.$route.query.type == 1 ? 2 : 1;
      }
      let that = this;
      let wxuserinfo = this.$route.query.userinfo;
      if (wxuserinfo != "" && wxuserinfo) {
        setWinfo(
          encrypt.Encrypt(JSON.stringify(JSON.parse(decodeURI(wxuserinfo))), "")
        );
        let userinfo = JSON.parse(decodeURI(wxuserinfo));
        this.loginType = userinfo.type == 1 ? 2 : 1;
        if (userinfo.status === 0) {
          this.$message(userinfo.msg);
        } else if (userinfo.status === 10) {
          this.$message("绑定微信成功,请绑定账号信息！");
        } else if (userinfo.status === 1) {
          removeWinfo();
          this.submitLogin2(userinfo);
        }
      }
    },
    submitLogin() {
      if (this.loginType == 1) {
        if (this.formLogin.loginUsername == "") {
          this.$message("用户名不得为空");
          return false;
        } else if (this.formLogin.loginPassword == "") {
          this.$message("密码不得为空");
          return false;
        } else {
          if (getWinfo() != "" && getWinfo() != null) {
            let params = {
              username: this.formLogin.loginUsername,
              password: this.formLogin.loginPassword,
              wxinfo: getWinfo(),
            };
            bindTeacherWx(params)
              .then(async (response) => {
                setToken(response.data.token);
                setUid(response.data.uid);
                resetRouter();
                var accessRoutes = await this.$store.dispatch(
                  "user/getRouter2"
                );
                var routers = newRoutes2;
                if (newRoutes2[0].children.length == 1) {
                  var child1 = newRoutes2[0].children.concat(accessRoutes);
                } else {
                  var child1 = newRoutes2[0].children
                    .slice(0, 1)
                    .concat(accessRoutes);
                }

                routers[0].children = child1;
                router.addRoutes(routers);
                router.options.routes = routers;
                setPhone("微信登录");
                setType(1);
                setActiveName("个人信息");
                removeActive();
                setActive2(1);
                this.$router.push({ name: "Common" });
                this.$message.success("登录成功");
              })
              .catch((error) => {
                this.$message.error(error.msg);
              });
            return false;
          } 
        }
      } else {
        if (this.formLogin.loginUsername == "") {
          this.$message("用户名不得为空");
          return false;
        } else if (this.formLogin.loginPassword == "") {
          this.$message("密码不得为空");
          return false;
        } else {
          if (getWinfo() != "" && getWinfo() != null) {
            let params = {
              username: this.formLogin.loginUsername,
              password: this.formLogin.loginPassword,
              wxinfo: getWinfo(),
            };
            bindStudentWx(params)
              .then(async (response) => {
                setToken(response.data.token);
                setUid(response.data.uid);
                resetRouter();
                var accessRoutes = await this.$store.dispatch("user/getRouter");
                var routers = newRoutes;
                if (newRoutes[0].children.length == 1) {
                  var child1 = newRoutes[0].children.concat(accessRoutes);
                } else {
                  var child1 = newRoutes[0].children
                    .slice(0, 9)
                    .concat(accessRoutes);
                }

                routers[0].children = child1;
                router.addRoutes(routers);
                router.options.routes = routers;
                setPhone("微信登录");
                setType(2);
                setActiveName("个人信息");
                removeActive();
                setActive2(1);
                this.$router.push({ name: "Common" });
                this.$message.success("登录成功");
              })
              .catch((error) => {
                this.$message.error(error.msg);
              });
            return false;
          }
        }
      }
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.bindWX();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
};
</script>
<style lang="scss" scoped>
.bind {
  height: 100%;
  font-size: 14px;

  @media screen and (max-width: 768px) {
    width: 100%;
  }
  .centered {
    margin: 0 auto;
    height: 100%;
    width: 450px;
    @media screen and (max-width: 768px) {
      width: 100%;
      padding-left: 20px;
    }
    .logo {
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        margin-top: 5px;
        width: 40px;
        height: 40px;
        display: inline-block;
      }
      span {
        display: inline-block;
        margin-left: 10px;
        font-size: 25px;
        color: #ffffff;
      }
    }
  }
  .top-box {
    height: 48px;
    width: 100%;
    background-color: #51b7ec;
  }
  .bind-box {
    margin: 50px auto;
    width: 450px;
    height: 320px;
    border: 2px solid green;
    @media screen and (max-width: 768px) {
      width: 80%;
    }
    h3 {
      font-size: 20px;
      color: #333;
      margin-top: 20px;
      margin-bottom: 60px;
      font-weight: normal;
      text-align: center;
    }
    input {
      padding: 10px 0 10px 10px;
      border: 1px solid rgb(195, 195, 195);
      line-height: 18px;
      width: 258px;
      height: 38px;
      display: block;
      outline: none;
      margin: 0 auto;
      border-radius: 6px;
      margin-bottom: 13px;
    }
    button {
      display: block;
      outline: none;
      border: none;
      width: 258px;
      background-color: #86ce2f;
      color: #fff;
      height: 40px;
      line-height: 35px;
      font-size: 17px;
      margin: 20px auto 0px;
      cursor: pointer;
    }
  }
}
</style>
